import {reactFetchJSON} from '@github-ui/verified-fetch'
import type {Milestone} from './milestone'
import type {GraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import {buildItemPickerSearchUrl} from '@github-ui/item-picker-base/api/urls'
import {SearchMilestones} from '@github-ui/server-persisted-queries'
import type {SearchMilestonesQuery} from '@github-ui/server-persisted-queries/types/SearchMilestones'

export type GetSearchMilestonesRequest = {
  owner: string
  repo: string
  query?: string
  count?: number
}

export type GetSearchMilestonesResponse = GraphQLResponse<SearchMilestonesQuery>

export async function apiGetSearchMilestones({
  owner,
  repo,
  query,
  count,
}: GetSearchMilestonesRequest): Promise<GetSearchMilestonesResponse> {
  const params: Record<string, unknown> = {owner, repo, queryId: SearchMilestones}

  if (query) {
    params['query'] = query
  }

  if (count) {
    params['count'] = count
  }

  const requestUrl = buildItemPickerSearchUrl('milestones', params)
  const request = await reactFetchJSON(requestUrl)
  return (await request.json()) as GetSearchMilestonesResponse
}

const itemPickerQueryKeyBase = 'item_picker'

export function buildMilestonePickerSearchQueryKey(searchParams: GetSearchMilestonesRequest) {
  return [itemPickerQueryKeyBase, 'milestones', searchParams]
}

export type MilestonePickerQueryData = {
  repositoryId: string
  milestones: Milestone[]
}

export function transformSearchMilestoneResponseToQueryData(response: SearchMilestonesQuery): MilestonePickerQueryData {
  if (!response.repository) {
    throw new Error('Repository not found in SearchMilestones response')
  }
  const nodes = response.repository.milestones?.nodes ?? []
  return {
    milestones: nodes.flatMap(node => (node ? [node] : [])),
    repositoryId: response.repository.id,
  }
}
